// import React from 'react';
// import { Chip } from '@mui/material';

// export const SOURCE_COLORS = {
//   LinkedIn: '#0A66C2',
//   Indeed: '#2164F3',
//   Workday: '#F9A21B',
//   Glassdoor: '#0CAA41',
//   ZipRecruiter: '#4A90D9',
//   Monster: '#6E46AE',
//   Dice: '#EA1C24',
// };
// export const DEFAULT_SOURCE_COLOR = '#6B7280';

// // `count` is optional: pass it for the toolbar's "LinkedIn: 22" breakdown chip,
// // omit it for the plain "LinkedIn" badge on an individual job card.
// export default function SourceChip({ source, count }) {
//   const color = SOURCE_COLORS[source] || DEFAULT_SOURCE_COLOR;
//   const label = count !== undefined ? `${source}: ${count}` : source;

//   return (
//     <Chip
//       label={label}
//       size="small"
//       variant="outlined"
//       sx={{
//         borderColor: color,
//         color,
//         fontWeight: 500,
//       }}
//     />
//   );
// }

import React from 'react';
import { Chip } from '@mui/material';

export const SOURCE_COLORS = {
  LinkedIn: '#0A66C2',
  Indeed: '#2164F3',
  Workday: '#F9A21B',
  Glassdoor: '#0CAA41',
  ZipRecruiter: '#4A90D9',
  Monster: '#6E46AE',
  Dice: '#EA1C24',
};
export const DEFAULT_SOURCE_COLOR = '#6B7280';

// `count` is optional: pass it for the toolbar's "LinkedIn: 22" breakdown chip,
// omit it for the plain "LinkedIn" badge on an individual job card.
// `onClick` and `active` are optional too — only the toolbar breakdown chips (which are
// clickable, to filter by source) pass these; a plain badge on a job card passes neither
// and renders exactly as before, non-interactive.
export default function SourceChip({ source, count, onClick, active = false }) {
  const color = SOURCE_COLORS[source] || DEFAULT_SOURCE_COLOR;
  const label = count !== undefined ? `${source}: ${count}` : source;
  const clickable = typeof onClick === 'function';

  return (
    <Chip
      label={label}
      size="small"
      variant={active ? 'filled' : 'outlined'}
      onClick={clickable ? onClick : undefined}
      clickable={clickable}
      sx={{
        borderColor: color,
        color: active ? '#fff' : color,
        backgroundColor: active ? color : 'transparent',
        fontWeight: 500,
        ...(clickable && {
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: active ? color : `${color}1A`, // ~10% tint on hover when inactive
          },
        }),
      }}
    />
  );
}